// import EDCJIT from "../assets/images/MyWork-SS/edcjit.jpeg";
import cadabams from "../assets/images/MyWork-SS/cadabams.jpeg";
// import destinationTechnologies from "../assets/images/MyWork-SS/destinationTechnologies.jpeg";
import GE from "../assets/images/MyWork-SS/GE.png";
import XR from "../assets/images/MyWork-SS/XR.png";

export const projects = [
  {
    image: XR,
    title: "Xtendr Technologies Pvt Ltd",
    roles: [
      {
  role: "Assistant Manager - Consumer Tech",
  duration: "16/01/2026 - Present",
  description: [
  "Building high-impact AR experiences and interactive projects using A-Frame and Three.js, directly contributing to client acquisition and user engagement.",

  "Playing a key role in developing the company's in-house AR platform, helping transition the business from purely service-based solutions to scalable product-driven offerings.",

  "Discovered and implemented a technique to emulate a 3D SLAM engine without requiring motion sensor permissions, significantly increasing user interactions and reducing onboarding friction.",

  "Developing unit tests to improve code reliability and quality, and deploying applications on AWS.",

  "Rapidly prototyping and delivering projects using AI-assisted development workflows, while reviewing and refining codebases developed by other team members."
],
},
      {
        role: "Software Development Intern",
        duration: "06/10/2025 - 15/01/2026 (3 Mos)",
        description: [
          "Developed interactive AR demos and prototypes using A-Frame and Three.js, supporting pre-sales and client pitches.",
          "Contributed to building immersive web-based AR experiences, improving client engagement during demos.",
        ],
      },
    ],
  },
  {
    image: GE,
    title: "Gokaldas Exports Ltd",
    role: "Software development and Security Intern",
    description: [
      "Spearheaded architectural design decisions among the interns, aligning system flow with business needs and ensuring performance and scalability.",
      "Designed and integrated secure, high-efficiency REST APIs to manage factory operations and streamline sensitive data flow, improving process efficiency by 20%.",
      "Built secure user authentication with JWT, role-based access control, and password policies — reducing unauthorized access by 80% with dynamic reporting filters.",
      "Authored dev documentation on system architecture and code. Co-created an user manual for the company users.",
    ],
    duration: "03/10/2024 - 24/01/2025 (4 Mos)",
  },
  {
    image: cadabams,
    title: "Cadabam's Group",
    role: "Software Development Intern",
    description: [
      "Developed backend APIs and data models using MERN stack to support scalable admin panel workflows and database relationships.",
      "Enhanced the appointment booking system by adding a doctor-filtering feature, improving usability and accessibility for patients.",
      "Collaborated with developers in code reviews and documentation, strengthening team coordination and development process.",
    ],
    duration: "01/02/2024 - 31/03/2024 (2 Mos)",
  }
];
